var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptiliftLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 33,
    viewBox: "0 0 55 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_22041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.3V6.05C11.044 6.05 15.433 16.8713 25.96 25.3H0ZM55 12.683C55 16.7035 52.1895 19.5388 48.2213 19.5388C45.2678 19.5388 43.7305 18.238 42.977 17.226L42.702 19.25H40.5625V0H43.1613V8.0685C44.275 6.69625 46.1973 5.76125 48.3478 5.76125C52.3022 5.76125 55 8.5965 55 12.683ZM52.206 12.6555C52.206 9.88625 50.4983 8.18125 47.6355 8.18125C44.7728 8.18125 43.065 9.88625 43.065 12.6555C43.065 15.4248 44.7728 17.1298 47.6355 17.1298C50.4983 17.1298 52.206 15.4248 52.206 12.6555ZM36.0388 0V19.25H38.6375V0H36.0388ZM28.6935 17.2948C26.7987 17.2948 24.8078 16.3708 23.7408 15.0425L21.989 16.7118C23.6995 18.6478 25.9353 19.5415 28.5835 19.5415C32.219 19.5415 34.5015 17.9218 34.5015 15.191C34.5015 9.51225 24.6372 13.0653 24.6372 9.86425C24.6372 8.69275 26.004 8.03 28.1298 8.03C30.0245 8.03 31.394 8.64325 32.2438 9.52325L33.9955 7.854C32.835 6.6055 30.6488 5.764 28.193 5.764C24.519 5.764 22.1018 7.502 22.1018 10.2548C22.1018 15.7768 31.9247 12.265 31.9247 15.4825C31.9247 16.6155 30.6433 17.2975 28.6908 17.2975L28.6935 17.2948ZM54.7113 23.375H26.62C32.4198 28.1077 41.3215 33 54.7113 33V23.375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_22041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptiliftLogoDark);
export default __webpack_public_path__ + "static/media/optilift-logo-dark.1bb2362ce5348bcf70734d1aa2b478f4.svg";
export { ForwardRef as ReactComponent };